import { useState } from "react";
import { Globe, X } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";

const NEW_HOST = "breedtrackers.com";

export const DomainNoticeBanner = () => {
  const { user, refresh } = useAuth();
  const { t } = useI18n();
  const [hidden, setHidden] = useState(false);

  const host = window.location.hostname;
  const onNewDomain = host === NEW_HOST || host.endsWith(`.${NEW_HOST}`) || host === "localhost";
  if (!user || user.domain_notice_dismissed || onNewDomain || hidden) return null;

  const dismiss = async () => {
    setHidden(true);
    try { await api.post("/auth/domain-notice/dismiss"); } catch {/* best-effort */}
    refresh();
  };

  return (
    <div
      className="bg-olive text-white px-4 sm:px-6 py-3 flex flex-wrap items-center gap-3"
      data-testid="domain-notice-banner"
      data-print-hide
    >
      <Globe className="w-5 h-5 shrink-0" />
      <div className="flex-1 min-w-[200px]">
        <div className="text-sm font-semibold">{t("domain.title")}</div>
        <div className="text-xs text-white/85">{t("domain.body")}</div>
      </div>
      <a
        href={`https://${NEW_HOST}`}
        target="_blank"
        rel="noreferrer"
        className="px-4 py-1.5 rounded-full bg-white text-olive text-sm font-semibold hover:bg-cream transition-colors"
        data-testid="domain-notice-open"
      >
        {t("domain.open")}
      </a>
      <button type="button" onClick={dismiss} className="opacity-80 hover:opacity-100 transition-opacity" aria-label="Dismiss" data-testid="domain-notice-dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
